import Echo from "laravel-echo";
import { io } from "socket.io-client";

export function createEcho(options) {
  return new Echo({
    broadcaster: "socket.io",
    client: io,
    ...options,
  });
}
